import React, { useState, useEffect, useRef } from "react";
import { VStack, Text } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";
import { useLocation, useHistory } from "react-router-dom";
import { authSubsPost } from "src/api/authSubs";
import DarkHeader from "src/layout/DarkHeader";
import { useDispatch } from "src/store";
import { login } from "src/store/auth";

const Verify = () => {
  const [status, setStatus] = useState({ message: "wait", color: "grey" });
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const verifyCalledRef = useRef(false);

  useEffect(() => {
    if (verifyCalledRef.current) return;
    verifyCalledRef.current = true;

    const params = new URLSearchParams(location.search);
    const data: any = {};
    for (const param of params) {
      data[param[0]] = param[1];
    }

    authSubsPost("/auth/verify", data)
      .then((res: any) => {
        if (res && res.id) {
          setStatus({ message: "verifySuccess", color: "green" });

          window.localStorage.setItem("__sal_auth", res.accessToken);
          if (res.refreshToken) {
            window.localStorage.setItem("__sal_auth_refresh", res.refreshToken);
          }
          if (navigator.serviceWorker.controller) {
            navigator.serviceWorker.controller.postMessage({
              type: "fromPage",
              message: res.accessToken,
            });
          }
          dispatch(login({ user: res }));

          const redirectUrl =
            res.subscriptionStatus === "approved" ? "/" : "/subscription";
          if (window.location.pathname !== redirectUrl) {
            history.replace(redirectUrl);
          }
        } else {
          setStatus({ message: "invalidToken", color: "red" });
        }
      })
      .catch(() => {
        verifyCalledRef.current = false;
        setStatus({ message: "wentWrong", color: "red" });
      });
  }, [dispatch, location.search, history]);

  return (
    <>
      <DarkHeader />
      <VStack width='100%' textAlign='center' padding='150px 0 50px 0'>
        <Text color={status.color}>
          <FormattedMessage id={status.message} />
        </Text>
      </VStack>
    </>
  );
};

export default Verify;
